import { Box, ColorProvider, DropdownOptions, FilterProvider, TooltipPopup } from 'dash-ui';
import { css } from 'styled-components';

import Container from 'flow-components/Container/Container';
import Header from 'flow-components/Header/Header';

import ViewedByAgentsWidget from './components/ViewedByAgentsWidget/ViewedByAgentsWidget';
import DownloadedFilesChartWidget from './components/DownloadedFilesChartWidget/DownloadedFilesChartWidget';
import DashboardFilters from './components/DashboardFilters/DashboardFilters';
import TopRowWidgets from './components/TopRowWidgets/TopRowWidgets';

const contentStyle = css`
  background-color: transparent;
  box-shadow: none;
`;

const Dashboard = () => {
  return (
    <FilterProvider>
      <Box w="100%">
        <DropdownOptions />
        <TooltipPopup />
        <Header />
        <Container
          contentStyle={contentStyle}
          contentTopBarElement={<DashboardFilters />}
        >
          <Box w="100%">
            <TopRowWidgets />
            <ColorProvider>
              <ViewedByAgentsWidget />
            </ColorProvider>
            <ColorProvider>
              <DownloadedFilesChartWidget />
            </ColorProvider>
          </Box>
        </Container>
      </Box>
    </FilterProvider>
  );
};

export default Dashboard;
